const demos = {
  BaseTable: () => import("./base/BaseTable"),
  Blank: () => import("./base/Blank"),
  Button: () => import("./base/Button"),
  Card: () => import("./base/Card"),
  Checkbox: () => import("./base/Checkbox"),
  Collapse: () => import("./base/Collapse"),
  ColorPicker: () => import("./base/ColorPicker"),
  Dialog: () => import("./base/Dialog"),
  Dropdown: () => import("./base/Dropdown"),
  DatePicker: () => import("./base/DatePicker"),
  BaseTable1: () => import("./base/BaseTable1"),
  Icon: () => import("./base/Icon"),
  SjImage: () => import("./base/Image"),
  Input: () => import("./base/Input"),
  Label: () => import("./base/Label"),
  Loading: () => import("./base/Loading"),
  MessageBox: () => import("./base/MessageBox"),
  Notify: () => import("./base/Notify"),
  Pagination: () => import("./base/Pagination"),
  Radio: () => import("./base/Radio"),
  Range: () => import("./base/Range"),
  Select: () => import("./base/Select"),
  Slider: () => import("./base/Slider"),
  SjSwitch: () => import("./base/Switch"),
  Tab: () => import("./base/Tab"),
  Tag: () => import("./base/Tag"),
  Tooltip: () => import("./base/Tooltip"),
  SearchInput: () => import("./advance/SearchInput"),
  LinkMenu: () => import("./advance/LinkMenu"),
  Upload: () => import("./base/Upload"),
  Download: () => import("./base/Download"),
  Drawer: () => import("./base/Drawer"),
  Menu: () => import("./base/Menu"),
  DropdownMenu: () => import("./base/DropdownMenu"),
  AutoComplete: () => import("./base/AutoComplete"),
  InputField: () => import("./advance/InputField"),
  PaginationTable: () => import("./advance/PaginationTable"),
  ContextMenu: () => import("./base/ContextMenu"),
  ScrollPageButtons: () => import("./advance/ScrollPageButtons"),
  ProcedureProgress: () => import("./base/ProcedureProgress"),
  NumberInput: () => import("./base/NumberInput")
};

const demoRoutes = Object.entries(demos).map(([name, component]) => {
  return {
    path: name,
    name,
    component
  };
});

export default demoRoutes;
